import { getModalActions } from '@tls/ui-modal';

import { ModalNames } from '../constants';

export const { showAction: showConfirmModal } = getModalActions(ModalNames.SHARED_CONFIRM_MODAL);
